import { Component, inject, Input, OnInit } from '@angular/core';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { TournamentCategory } from '../shared/tournament-category';
import { CommonModule } from '@angular/common';
import { CategoryFinal } from '../shared/category-final';
import { Player } from '../shared/model/player';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SetOrderPlayerFinalComponent } from '../admin/set-order-player-final-component/set-order-player-final-component';
import { MatDialog } from '@angular/material/dialog';
import { SetEndPlayerComponent } from '../set-end-player-component/set-end-player-component';

export interface CategoryFinalWithPlayer extends CategoryFinal {
  player1?: Player;
  player2?: Player;
}

@Component({
  selector: 'app-category-final-component',
  imports: [CommonModule],
  templateUrl: './category-final-component.html',
  styleUrl: './category-final-component.scss'
})
export class CategoryFinalComponent implements OnInit {

  @Input() category!: TournamentCategory | undefined;

  players: Player[] = [];
  categoryType: string | null = null;
  quarterFinals: CategoryFinalWithPlayer[] | undefined;
  semiFinals: CategoryFinalWithPlayer[] | undefined;
  final: CategoryFinalWithPlayer | undefined;

  esAdmin$!: Observable<boolean>;

  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);
  private snackBar = inject(MatSnackBar);

  constructor() {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.getPlayers().subscribe((players) => this.players = players);
  }

  ngOnInit() {
    this.quarterFinals = (this.category && this.category.finals && this.category.finals.quarterfinals)
      ? this.category.finals.quarterfinals.sort((a, b) => a.order - b.order)
      : undefined;
    this.quarterFinals?.map(qf => {
      qf.player1 = qf.player1Id ? this.getPlayer(qf.player1Id) : undefined;
      qf.player2 = qf.player2Id ? this.getPlayer(qf.player2Id) : undefined;
      return qf;
    });
    this.semiFinals = (this.category && this.category.finals && this.category.finals.semifinals)
      ? this.category.finals.semifinals.sort((a, b) => a.order - b.order)
      : undefined;
    this.semiFinals?.map(sf => {
      sf.player1 = sf.player1Id ? this.getPlayer(sf.player1Id) : undefined;
      sf.player2 = sf.player2Id ? this.getPlayer(sf.player2Id) : undefined;
      return sf;
    });
    this.final = (this.category && this.category.finals)
      ? this.category.finals.final
      : undefined;
    if (this.final) {
      this.final.player1 = this.final.player1Id ? this.getPlayer(this.final.player1Id) : undefined;
      this.final.player2 = this.final.player2Id ? this.getPlayer(this.final.player2Id) : undefined;
    }
  }

  getPlayer(playerId: string): Player | undefined {
    return this.players.find(player => player.playerId === playerId);
  }

  setPlayer(data: CategoryFinal) {
    console.log('set player', data);
    console.log('category', this.category);

    this.dialog.open(SetOrderPlayerFinalComponent, {
      data: {
        match: data,
        category: this.category
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.snackBar.open(`Se guardo el jugador correctamente`, 'Cerrar', {
          duration: 3000
        });
      }
    });
  }

  generarFinales() {
    if (this.category) {
      const sinceQuarterFinalsNoBye = false;
      const sinceQuarterFinals = false;
      const sinceSemiFinals = true;
      const sinceSemiFinalsOneGroup = false;
      const sinceFinal = false;

      if (sinceQuarterFinalsNoBye) {
        this.category.hasQuarterFinals = true;
        this.category.hasSemiFinals = true;
        this.category.hasFinal = true;
        this.category.finals = {
          quarterfinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: '1ro Grupo A',
              player2Id: '',
              player2Label: '3ro Grupo B',
            },
            {
              order: 2,
              player1Id: '',
              player1Label: '2do Grupo B',
              player2Id: '',
              player2Label: '2do Grupo C',
            },
            {
              order: 3,
              player1Id: '',
              player1Label: '1ro Grupo C',
              player2Id: '',
              player2Label: '2do Grupo A',
            },
            {
              order: 4,
              player1Id: '',
              player1Label: '3ro Grupo A',
              player2Id: '',
              player2Label: '1ro Grupo B',
            }
          ],
          semifinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: 'Ganador Cuartos 1',
              player2Id: '',
              player2Label: 'Ganador Cuartos 2',
            },
            {
              order: 2,
              player1Id: '',
              player1Label: 'Ganador Cuartos 3',
              player2Id: '',
              player2Label: 'Ganador Cuartos 4',
            }
          ],
          final: {
            order: 1,
            player1Id: '',
            player1Label: 'Ganador Semifinal 1',
            player2Id: '',
            player2Label: 'Ganador Semifinal 2',
          }
        };
      } else if (sinceQuarterFinals) {
        this.category.hasQuarterFinals = true;
        this.category.hasSemiFinals = true;
        this.category.hasFinal = true;
        this.category.finals = {
          quarterfinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: '1er Primero',
              player2Bye: true,
            },
            {
              order: 2,
              player1Id: '',
              player1Label: '3er Primero',
              player2Id: '',
              player2Label: '3er Segundo',
            },
            {
              order: 3,
              player1Id: '',
              player1Label: '1er Segundo',
              player2Id: '',
              player2Label: '2do Segundo',
            },
            {
              order: 4,
              player1Bye: true,
              player2Id: '',
              player2Label: '2do Primero',
            }
          ],
          semifinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: '1er Primero',
              player2Id: '',
              player2Label: 'Ganador Cuartos 1',
            },
            {
              order: 2,
              player1Id: '',
              player1Label: 'Ganador Cuartos 2',
              player2Id: '',
              player2Label: '2do Primero',
            }
          ],
          final: {
            order: 1,
            player1Id: '',
            player1Label: 'Ganador Semifinal 1',
            player2Id: '',
            player2Label: 'Ganador Semifinal 2',
          }
        };
      } else if (sinceQuarterFinals) {
        this.category.hasQuarterFinals = true;
        this.category.hasSemiFinals = true;
        this.category.hasFinal = true;
        this.category.finals = {
          quarterfinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: '1er Primero',
              player2Bye: true,
            },
            {
              order: 2,
              player1Id: '',
              player1Label: '3er Primero',
              player2Id: '',
              player2Label: '3er Segundo',
            },
            {
              order: 3,
              player1Id: '',
              player1Label: '1er Segundo',
              player2Id: '',
              player2Label: '2do Segundo',
            },
            {
              order: 4,
              player1Bye: true,
              player2Id: '',
              player2Label: '2do Primero',
            }
          ],
          semifinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: '1er Primero',
              player2Id: '',
              player2Label: 'Ganador Cuartos 1',
            },
            {
              order: 2,
              player1Id: '',
              player1Label: 'Ganador Cuartos 2',
              player2Id: '',
              player2Label: '2do Primero',
            }
          ],
          final: {
            order: 1,
            player1Id: '',
            player1Label: 'Ganador Semifinal 1',
            player2Id: '',
            player2Label: 'Ganador Semifinal 2',
          }
        };
      } else if (sinceSemiFinalsOneGroup) {
        this.category.hasSemiFinals = true;
        this.category.hasFinal = true;

        this.category.finals = {
          semifinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: 'Primero',
              player2Id: '',
              player2Label: 'Cuarto',
            },
            {
              order: 2,
              player1Id: '',
              player1Label: 'Segundo',
              player2Id: '',
              player2Label: 'Tercero',
            }
          ],
          final: {
            order: 1,
            player1Id: '',
            player1Label: 'Ganador Semifinal 1',
            player2Id: '',
            player2Label: 'Ganador Semifinal 2',
          }
        };
      } else if (sinceSemiFinals) {
        this.category.hasSemiFinals = true;
        this.category.hasFinal = true;

        this.category.finals = {
          semifinals: [
            {
              order: 1,
              player1Id: '',
              player1Label: '1ro Grupo A',
              player2Id: '',
              player2Label: '2do Grupo B',
            },
            {
              order: 2,
              player1Id: '',
              player1Label: '1ro Grupo B',
              player2Id: '',
              player2Label: '2do Grupo A',
            }
          ],
          final: {
            order: 1,
            player1Id: '',
            player1Label: 'Ganador Semifinal 1',
            player2Id: '',
            player2Label: 'Ganador Semifinal 2',
          }
        };
      } else if (sinceFinal) {
        this.category.hasFinal = true;
        this.category.finals = {
          final: {
            order: 1,
            player1Id: '',
            player1Label: 'Primero',
            player2Id: '',
            player2Label: 'Segundo',
          }
        };
      }
      console.log('Finales generadas', this.category);
      
      this.openSquashService.updateCategory(this.category!).subscribe();
    }
  }

  setEndPlayer(stage: string, match: number, player: number) {
    this.dialog.open(SetEndPlayerComponent, {
      data: {
        stage: stage,
        match: match,
        player: player,
        category: this.category
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.snackBar.open(`Se finalizó la asignación de jugador`, 'Cerrar', {
          duration: 3000
        });
      }
    });
  }

  doSomething() {
    console.log('Doing something...');
  }
}
